import { useEffect, useRef, useCallback } from 'react';

import { BackendAgentStatus } from '../context-providers/TwilioContext/TwilioContext';

type CrossTabMessage = {
  type: 'status_change';
  status: BackendAgentStatus;
  identity: string;
  timestamp: number;
};

type CrossTabSyncOptions = {
  identity: string;
  onStatusChange: (status: BackendAgentStatus) => void;
};

const CHANNEL_NAME = 'ergeon-phone-status';

export const useCrossTabSync = ({ identity, onStatusChange }: CrossTabSyncOptions) => {
  const channelRef = useRef<BroadcastChannel | null>(null);

  useEffect(() => {
    if (!identity) return;

    const channel = new BroadcastChannel(CHANNEL_NAME);
    channelRef.current = channel;

    channel.onmessage = (event: MessageEvent<CrossTabMessage>) => {
      const message = event.data;
      if (message.type === 'status_change' && message.identity === identity) {
        onStatusChange(message.status);
      }
    };

    return () => {
      channel.close();
      channelRef.current = null;
    };
  }, [identity, onStatusChange]);

  const broadcastStatus = useCallback(
    (status: BackendAgentStatus) => {
      if (channelRef.current && identity) {
        const message: CrossTabMessage = {
          type: 'status_change',
          status,
          identity,
          timestamp: Date.now(),
        };
        channelRef.current.postMessage(message);
      }
    },
    [identity],
  );

  return { broadcastStatus };
};
